const YUXIE_WEB_APP_ID = 'wxe27fd0d4f0978882';
const SHIJIAN_WEB_APP_ID = 'wx49a29123fe4fbe9e';

export function isLocalHost(hostname = window.location.hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getWebLoginAppId(hostname = window.location.hostname) {
  return hostname === 'i.shijian.vip' ? SHIJIAN_WEB_APP_ID : YUXIE_WEB_APP_ID;
}

export function buildWebLoginRedirectUri(appId = getWebLoginAppId(), loc = window.location) {
  const origin = loc.origin || `${loc.protocol}//${loc.host}`;
  return `${origin}/api/login/doLogin?appId=${appId}`;
}

export function applyWebLoginConfig(config = {}) {
  window.app = window.app || {};
  const appId = config.appId || getWebLoginAppId();
  window.app.appId = appId;
  window.app.redirectUri = buildWebLoginRedirectUri(appId);

  if (config.biz) {
    window.app.biz = config.biz;
  }
  if (config.name) {
    window.app.name = config.name;
  }
  if (config.serviceAppId) {
    window.app.serviceAppId = config.serviceAppId;
  }

  return {
    appId: window.app.appId,
    redirectUri: window.app.redirectUri,
  };
}

export { YUXIE_WEB_APP_ID, SHIJIAN_WEB_APP_ID };
